import * as React from "react";
import { connect } from "react-redux";
import Select from 'react-dropdown-select';
import { ApplicationState } from "../../store";
import Swal from 'sweetalert2'
import * as SftpConfigModels from '../../models/config/SftpConfig'
import * as SftpConfigStore from '../../store/config/SftpConfig'

type conditionProps = SftpConfigModels.GetSftpConfigState & typeof SftpConfigStore.actionCreators

export interface inititem {
    value: "",
    label: "",
    display: ""
};

class AutocompleteSftpServer extends React.Component<any, { response: any, p: boolean, dataResult: Array<inititem>, dataSearch: Array<inititem>, checkSearch: boolean, checkValue: boolean, companycodereq: string, sidreq: string }, conditionProps> {
    constructor(props: any) {
        super(props);
        this.state = {
            response: "",
            p: true,
            dataResult: [],
            dataSearch: [],
            checkSearch: true,
            checkValue: true,
            companycodereq: '',
            sidreq: ''
        }
    }

    componentDidMount() {
        const { sid, companycode } = this.props
        if (sid != "") {
            this.props.requestGetSftpConfig(true, "GET", sid,  "", "")
            this.setState({
                sidreq: this.props.sid,
                companycodereq: this.props.companycode,
                checkValue: false
            })
        }
    }

    componentDidUpdate(nextProps: any, nextState: any) {
        const { sid, companycode, GetSftp, valueSearch } = this.props
        if (sid != this.state.sidreq) {
            this.props.requestGetSftpConfig(true, "GET", sid, "", "")
            this.setState({
                sidreq: this.props.sid,
                companycodereq: this.props.companycode,
                checkValue: false
            })
        }

        if (GetSftp.statusSftpConfig == 200 && GetSftp.isLoadSftpConfig && GetSftp.responseSftpConfig['result_list'] != undefined && !this.state.checkValue) {
            var dataArr: any = []
            var dataFindArr = ""
            var dataFindLabel = ""
            var dataRes = GetSftp.responseSftpConfig['result_list']
            for (let i = 0; i < dataRes.length; i++) {
                var dataReq = {}
                dataReq['value'] = dataRes[i].sftp_server_id
                dataReq['display'] = dataRes[i].sftp_server_id + ' , ' + dataRes[i].sftp_ip
                dataReq['label'] = dataRes[i].sftp_server_id + '|' + dataRes[i].sftp_ip + '|' + dataRes[i].sftp_port + '|' + dataRes[i].sftp_username + '|' + dataRes[i].sftp_password + '|' + dataRes[i].private_key
                dataArr.push(dataReq)

                if (dataRes[i].sftp_server_id == valueSearch && valueSearch != "") {
                    dataFindArr = dataRes[i].sftp_server_id + ' , ' + dataRes[i].sftp_ip
                    dataFindLabel = dataRes[i].sftp_server_id + '|' + dataRes[i].sftp_ip + '|' + dataRes[i].sftp_port + '|' + dataRes[i].sftp_username + '|' + dataRes[i].sftp_password + '|' + dataRes[i].private_key
                }
            }
            var dataSearchArr: any = []
            var dataSearch = {}
            dataSearch['value'] = valueSearch
            dataSearch['display'] = dataFindArr
            dataSearch['label'] = dataFindLabel
            dataSearchArr.push(dataSearch)

            this.setState({
                dataResult: dataArr,
                checkValue: true,
                dataSearch: dataSearchArr
            })
            console.log(dataSearch)
        }
    }

    render() {
        return (
            <Select
                options={this.state.dataResult}
                searchBy="display"
                labelField="display"
                valueField="value"
                values={this.state.dataSearch}
                dropdownGap={5}
                required={true}
                onChange={(value) => this.props.handlechageSftpServerID(value[0].value, this.props.keyReq, value[0].label)}
                loading={this.state.checkValue ? false : true}
            />
        )
    }
}
export default connect((state: ApplicationState) => ({ ...state.SftpConfig }), ({ ...SftpConfigStore.actionCreators }))(AutocompleteSftpServer)
